import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isModalOpen: false,
    hasCheckedPin: false,
    previousAccountId: null,
};
const pinCreationSlice = createSlice({
    name: 'pinCreation',
    initialState,
    reducers: {
        setModalOpen: (state, action) => {
            const { isOpen } = action.payload;
            state.isModalOpen = isOpen;
        },
        setHasCheckedPin: (state, action) => {
            const { hasChecked } = action.payload;
            state.hasCheckedPin = hasChecked;
        },
        setPreviousAccountId: (state, action) => {
            const { accountId } = action.payload;
            state.previousAccountId = accountId;
        },
        resetPinCreationState: state => {
            state.isModalOpen = false;
            state.hasCheckedPin = false;
            state.previousAccountId = null;
        },
    },
});
export const { setModalOpen, setHasCheckedPin, setPreviousAccountId, resetPinCreationState } = pinCreationSlice.actions;
export default pinCreationSlice.reducer;
